<template>
	<div class="news">
		<div class="news-list" >
      <div class="flex align-center titleTip">
        <div class="iconBack">
          <img src="@/assets/images/icon-Back.png" class="iconBack"  alt=""/>
        </div>
        <div @click="$router.push('/')" class="cursor homeText">首页</div>
        <div class="el-icon-arrow-right"></div>
        <div class="homeLabel">行业动态</div>
      </div>
      <!--列表数据-->
      <div class="cards">
        <div v-for="(item, index) in tableData" :key="index" @click="lookDetail(item)" class="cardsItem flex align-center justify-between">
          <div class="flex align-center">
            <img src="@/assets/images/icon_list_point.png" alt=""/>
            <div class="cardsItemText">{{ item.noticeTitle }}</div>
          </div>
          <div class="cardsItemTime">{{ item.createTime.substring(0, 10) }}</div>
        </div>
        <el-pagination
            class="pagination"
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout="total, prev, pager, next"
            :page-size="pageSize"
            :total="totalAll"
            :hide-on-single-page="true"/>
      </div>
		</div>
	</div>
</template>

<script>
	import '@/assets/css/news.less';
  import {noticeListAPI} from "@/api/home";
	export default {
		name: 'index',
		data() {
			return {
        pageSize: 10,
        currentPage: 1,
        allData: [],
        tableData: [],
        totalAll: 0,
			};
		},
    mounted() {
      this.getlist(this.$route.query.type)
    },
		methods: {
      // 通知公示列表
      getlist(type) {
        noticeListAPI(type).then(res => {
          const {code, rows, total, msg} = res
          if (code === 200) {
            this.allData = rows
            this.tableData = rows.slice(0, this.pageSize)
            // 计算总数
            this.totalAll = total
          } else {
            this.$message.error(msg || '获取列表失败')
          }
        })
      },
      lookDetail(row) {
        sessionStorage.setItem('type', row.noticeType)
        this.$router.push('/newsDetails?newsId=' + row.noticeId)
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        const start = (val - 1) * this.pageSize;
        const end = val * this.pageSize;
        this.tableData = this.allData.slice(start, end);
      },
		},
	};
</script>
